module.exports = __webpack_public_path__ + "icomoon.5244765b2917ee536d2d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vendors/by_hands/font-icomoon/fonts/icomoon.svg?mkks98
// module id = ./src/assets/vendors/by_hands/font-icomoon/fonts/icomoon.svg?mkks98
// module chunks = styles